import { Map, List } from 'immutable';
import { combineImmutableReducers } from '../../util';
import ACTIONS from '../actions';
import session_actions from '../../session/actions';

const DEFAULT_ITEMS = new Map();
const DEFAULT_ITEMS_LIST = new List();

function pendingById(state = DEFAULT_ITEMS, action) {

  if (action.type === session_actions.LOGOUT){
    return DEFAULT_ITEMS
  }

  if (action.type === ACTIONS.ADD_PENDING_SNAP){
    return state.merge(new Map({[action.props.pending_id]: action.props}));
  }

  if (action.type === ACTIONS.SNAP_FORM_SUCCESS){
    return state.delete(Object.values(action.response.entities.items)[0].pending_id)
  }

  return state;
}

function byId(state = DEFAULT_ITEMS, action) {

  if (action.type === session_actions.LOGOUT){
    return DEFAULT_ITEMS
  }

  if (action.type === ACTIONS.FETCHED_ITEMS_SUCCESS){
    if (typeof action.response.entities.items !== 'undefined'){
      return (new Map(action.response.entities.items)).map(c => new Map(c))
    }else{
      return DEFAULT_ITEMS
    }

  }

  if (action.type === ACTIONS.EDIT_ITEM_CATEGORY_ID){
    return state.updateIn([action.item_id, 'category_id'], (c) => action.category_id);
  }

  if (action.type === ACTIONS.EDIT_ITEM_CATEGORY_NAME){
    return state.updateIn([action.item_id, 'name'], (c) => action.name);
  }

  if (action.type === ACTIONS.DELETING_ITEM){
    return state.delete(action.item_id)
  }

  if (action.response && action.response.entities && action.response.entities.items) {
    return state.merge((new Map(action.response.entities.items)).map(c => new Map(c)));
  }
  return state;
}


function pendingIds(state = DEFAULT_ITEMS_LIST, action) {
  switch (action.type) {
    case session_actions.LOGOUT:
      return DEFAULT_ITEMS_LIST
    case ACTIONS.ADD_PENDING_SNAP:
      return state.insert(0,action.props.pending_id)
    case ACTIONS.SNAP_FORM_SUCCESS:
      return state.delete(state.indexOf(Object.values(action.response.entities.items)[0].pending_id))
  default:
    return state;
  }
}

// Reducer to keep master list of ids
function ids(state = DEFAULT_ITEMS_LIST, action) {
  switch (action.type) {
    case ACTIONS.FETCHED_ITEMS_SUCCESS:
      if (typeof action.response.entities.items !== 'undefined' ){
        return new List(Object.keys(action.response.entities.items))
      }else{
        return DEFAULT_ITEMS_LIST
      }
    case ACTIONS.SNAP_FORM_SUCCESS:
      return state.insert(0,Object.keys(action.response.entities.items)[0])
    case ACTIONS.DELETING_ITEM:
      return state.delete(state.indexOf(action.item_id))
    case session_actions.LOGOUT:
      return DEFAULT_ITEMS_LIST
  // case actions.LOAD_ITEMS_SUCCESS:
  //   return new List(action.response.result);
  default:
    return state;
  }
}

const DEFAULT_DRAFT = new Map({venue_permalink:'', venue_id: '', image: '', submitting: false, category_id: '', name: '', description: '', internal_notes: ''});

function draft(state = DEFAULT_DRAFT, action) {
  switch (action.type) {
    case ACTIONS.CLEAR_DRAFT_ITEM_NAME:
      return state.merge({name:''})
    case ACTIONS.ADD_DRAFT_ITEM_IMAGE:
      return state.merge({image:action.image})
    case ACTIONS.CLEAR_DRAFT_ITEM_IMAGE:
      return state.merge({image:''})
    case ACTIONS.CLEAR_DRAFT_ITEM_CATEGORY_ID:
      return state.merge({category_id:''})
    case ACTIONS.ADD_DRAFT_ITEM_CATEGORY_ID:
      return state.merge({category_id:action.id})
    case ACTIONS.ADD_DRAFT_ITEM_CATEGORY_NAME:
      return state.merge({name:action.name})
    case ACTIONS.ADD_DRAFT_ITEM_VENUE_ID:
      return state.merge({venue_id:action.id})
    case ACTIONS.ADD_DRAFT_ITEM_VENUE_PERMALINK:
      return state.merge({venue_permalink:action.venue_permalink})
    case ACTIONS.CODE_LOGIN_FORM_SUCCESS:
    case ACTIONS.LOGIN_FORM_SUCCESS:
      //populate the initial venue_id of the draft item
      const user = new Map(action.response.entities.users[action.response.result.user])
      return state.merge({
        venue_id: user.getIn(["venues"])[0]["id"].toString(),
        venue_permalink: user.getIn(["venues"])[0]["permalink"]
      });
    case ACTIONS.CLEAR_DRAFT_ITEM:
      return DEFAULT_DRAFT.merge({
        venue_id: state.get("venue_id"),
        venue_permalink: state.get("venue_permalink")
      });
    case ACTIONS.SNAP_FORM_SUBMITTING:
      return state.merge({submitting:true})
    case ACTIONS.SNAP_FORM_SUCCESS:
    case ACTIONS.SNAP_FORM_FAILURE:
      return state.merge({submitting:false})

    case ACTIONS.ADD_PENDING_SNAP:
      return DEFAULT_DRAFT.merge({venue_id: state.get("venue_id"),venue_permalink: state.get("venue_permalink")})
    case session_actions.LOGOUT:
      return DEFAULT_DRAFT

  // case ACTIONS.INIT:
  //   return DEFAULT_DRAFT;
  // case ACTIONS.NEW_ITEM_REQUEST:
  //   return state.merge({ submitting: true });
  // case ACTIONS.NEW_ITEM_SUCCESS:
  //   return state.merge({ submitting: false, body: '' });
  // case ACTIONS.NEW_ITEM_FAILURE:
  //   return state.merge({ submitting: false });
  // case ACTIONS.UPDATE_DRAFT_ITEM:
  //   return state.merge({ body: action.body });
  default:
    return state;
  }
}

// Build our reducer using `combineImmutableReducers`
const reducer = combineImmutableReducers({
  byId,
  ids,
  draft,
  pendingIds,
  pendingById
});

export default reducer;

export const getDraftItem = (state) => state.get("draft")

export const getItemsById = (state) => state.get("byId")

export const getItemIds = (state) => state.get("ids")

export const getPendingItemIds = (state) => state.get("pendingIds")

export const getPendingItems = (state) => state.get("pendingById")




// WEBPACK FOOTER //
// ./src/snapit_app/reducers/items.js